import React from "react";
import loadable from '@loadable/component'
import { Route, Switch } from "react-router-dom";
import slugify from 'react-slugify';

import Home from "./containers/Home";

const Reviews = loadable(() => import( /* webpackChunkName: "reviews" */  './containers/Reviews'));
const Therapists = loadable(() => import( /* webpackChunkName: "therapists" */  './containers/Therapists'));
const Treatments = loadable(() => import( /* webpackChunkName: "treatments" */  './containers/Treatments'));
const Treatment = loadable(() => import( /* webpackChunkName: "treatment" */  './containers/Treatment'));
const Salon = loadable(() => import( /* webpackChunkName: "treatment" */  './containers/Salon'));
const NotFound = loadable(() => import( /* webpackChunkName: "notfound" */  './containers/NotFound'));


const componentRegistry = {
  "Home": Home,
  "Reviews": Reviews,
  "Therapists": Therapists,
  "Treatment": Treatment,
  "Treatments": Treatments,
  "Salon": Salon
}

const ContentRoutes = (props) => (
  props.contentData[0].fields.navLinks.map((link, i) => (link.fields.navLinks
      ?[
        <Route key={link.fields.heading} path={props.pathPrefix + '/' + slugify(link.fields.heading)} exact render={
          (routeData, component=link.fields.component, contentData=link) => (React.createElement(componentRegistry[component], {component: component, routeData:routeData, contentData:contentData}, null))
        } />,
        <ContentRoutes key={i} contentData={[link]} pathPrefix={props.pathPrefix + link.fields.path}/>
      ]
      :<Route key={i} path={props.pathPrefix + '/' + slugify(link.fields.heading)} exact render={
          (routeData, component=link.fields.component, contentData=link) => (React.createElement(componentRegistry[component], {component: component, routeData:routeData, contentData:contentData}, null))
        } />
  ))
)

const Routes = (props) => (
  <Switch>
    { /* Static Routes */ }
    <Route path="/" exact component={Home} />
    <Route path="/reviews" exact component={Reviews} />

    { /* Dynamic Routes from Contentfull */ }
    {props.contentData && <ContentRoutes contentData={props.contentData} pathPrefix={''}/>}

    { /* Route To Theme Test */ }
    {/* <Route path="/theme" exact component={Theme} /> */} */}

    { /* Finally, catch all unmatched routes */ } */}
    <Route component={NotFound} />
  </Switch>
)

export default Routes;